import styled from "styled-components";

export const CursorPointStyled = styled.div`
  cursor: pointer;
`;